// extracted by mini-css-extract-plugin
module.exports = {"title":"_3oUd6X"};